import React from 'react';
import MetaControl from 'Components/UI/Meta/MetaControl';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDTooltip, FDIcon } from '@facet-wealth/design';

const QualifiedWithdrawalTooltip = () => {
  const { resource, handleChange } = useMetaLayoutContext();

  return (
    <>
      <MetaControl
        resource={resource}
        attrName={'isQualifiedWithdrawal'}
        onChange={newVal => handleChange('isQualifiedWithdrawal', newVal)}
      />
      <FDTooltip title={'We will apply early withdrawal penalties if this is not checked and the withdrawal is made before qualified withdrawals are assumed'}>
        <FDIcon
          alignSelf="center"
          color="primary"
          icon="info"
          size="md"
        />
      </FDTooltip>
    </>
  );
};

QualifiedWithdrawalTooltip.defaultProps = {
};

QualifiedWithdrawalTooltip.propTypes = {
};

export default QualifiedWithdrawalTooltip;
